import React, { useState, useEffect } from 'react';
import { X, MessageSquare } from 'lucide-react';

export const FEEDBACK_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLScGEpPncZkf1Kwpv4RCcv-cvC0oB-mIZcJMrhfu_2PwiJMlxQ/viewform?usp=header';
const STORAGE_KEY = 'feedbackBannerDismissedAt';
const DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const FeedbackBanner = () => {
  const [dismissed, setDismissed] = useState(true); // Start hidden to prevent flash

  useEffect(() => {
    const dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (dismissedAt) {
      const elapsed = Date.now() - parseInt(dismissedAt, 10);
      // Show again if 7 days have passed
      setDismissed(elapsed < DISMISS_DURATION_MS);
    } else {
      setDismissed(false);
    }
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  };

  if (dismissed) return null;

  return (
    <div className="bg-gathering-green text-white text-sm">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-1 justify-center">
          <MessageSquare size={16} className="flex-shrink-0" />
          <span>
            We're still cooking! 🥪{' '}
            <a
              href={FEEDBACK_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="underline font-semibold hover:text-discovery-gold transition-colors"
            >
              Share your feedback
            </a>{' '}
            and help us make Club Sandwich better.
          </span>
        </div>
        <button
          onClick={handleDismiss}
          className="p-1 hover:bg-white/20 rounded transition-colors flex-shrink-0"
          aria-label="Dismiss feedback banner"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default FeedbackBanner;

